import React, { useEffect, useState } from 'react';
import { settings as settingsApi } from '@/utils/api';
import { Plus, Trash2, X } from 'lucide-react';
import { toast } from 'sonner';

export default function ProjectTypesPanel() {
  const [types, setTypes] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: '', description: '', icon: 'Layers' });

  useEffect(() => {
    settingsApi.projectTypes().then(r => setTypes(r.data));
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const r = await settingsApi.createProjectType(form);
      setTypes(prev => [...prev, r.data]);
      setShowCreate(false);
      setForm({ name: '', description: '', icon: 'Layers' });
      toast.success('Project type created');
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  const handleDelete = async (id) => {
    try {
      await settingsApi.deleteProjectType(id);
      setTypes(prev => prev.filter(t => t.id !== id));
      toast.success('Deleted');
    } catch { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-bold" style={{ color: 'var(--ink)' }}>Project Types</h2>
        <button className="btn-primary text-xs flex items-center gap-1.5 px-3 py-1.5" onClick={() => setShowCreate(true)} data-testid="add-project-type-button">
          <Plus size={13} /> Add Type
        </button>
      </div>

      <div className="space-y-2">
        {types.map(t => (
          <div key={t.id} className="card-base p-3 flex items-center justify-between" data-testid={`project-type-${t.id}`}>
            <div>
              <p className="font-semibold text-sm" style={{ color: 'var(--ink)' }}>{t.name}</p>
              <p className="text-xs" style={{ color: 'var(--muted)' }}>{t.description}</p>
            </div>
            <button onClick={() => handleDelete(t.id)} className="p-1.5 rounded-btn transition-colors hover:bg-red-50" style={{ color: '#B34A3A' }} data-testid={`delete-project-type-${t.id}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>

      {showCreate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="card-base w-full max-w-sm p-5 animate-fade-in">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-bold" style={{ color: 'var(--ink)' }}>New Project Type</h3>
              <button onClick={() => setShowCreate(false)} style={{ color: 'var(--muted)' }}><X size={16} /></button>
            </div>
            <form onSubmit={handleCreate} className="space-y-3">
              <div><label className="block text-xs font-semibold mb-1 uppercase tracking-wide" style={{ color: 'var(--muted)' }}>Name *</label><input className="input-agency text-sm" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} /></div>
              <div><label className="block text-xs font-semibold mb-1 uppercase tracking-wide" style={{ color: 'var(--muted)' }}>Description</label><input className="input-agency text-sm" value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
              <div className="flex gap-3"><button type="button" className="flex-1 py-2 text-sm rounded-btn border font-medium" style={{ borderColor: 'var(--border)', color: 'var(--muted)' }} onClick={() => setShowCreate(false)}>Cancel</button><button type="submit" className="flex-1 btn-primary py-2 text-sm" data-testid="create-project-type-submit">Create</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
